<template>
  <p style="margin-bottom: 0">
    <span :style="color" class="status-style">
      {{ status }}
    </span>
    <slot name="pendingReason" />
  </p>
</template>

<script>
  export default {
    props: {
      status: {},
      pendingReason: {},
    },
    data() {
      return {
        statusColors: {
          PENDING_SITE_ACTION: { background: '#FF9495', color: '#FFFFFF' },
          EXPIRED: { background: '#FF9495', color: '#FFFFFF' },
          IN_PROGRESS: { background: '#00B3FF', color: '#FFFFFF' },
          PENDING_PFIZER_ACTION: { background: '#00B3FF', color: '#FFFFFF' },
          COMPLETED: { background: '#7070D6', color: '#FFFFFF' },
          NOTFOUND: { background: 'rgba(0, 100, 193, 0.1)', color: '#0064C1' },
        },
      };
    },
    computed: {
      color() {
        if (this.status.includes('PENDING PFIZER ACTION')) {
          return this.statusColors['PENDING_PFIZER_ACTION'];
        }
        if (this.status.includes('PENDING SITE ACTION')) {
          return this.statusColors['PENDING_SITE_ACTION'];
        }
        if (this.status.includes('IN PROGRESS')) {
          return this.statusColors['IN_PROGRESS'];
        }
        if (this.status.includes('COMPLETED')) {
          return this.statusColors['COMPLETED'];
        }
        if (this.status.includes('EXPIRED')) {
          return this.statusColors['EXPIRED'];
        }
        return this.statusColors['NOTFOUND'];
      },
    },
  };
</script>

<style></style>
